module.exports = __webpack_public_path__ + "static/media/logoutIcon.811f8165.svg";